export default __webpack_public_path__ + "static/media/bear.57fb0d60.png";